import { IDropdownOption } from "@fluentui/react";

/**
 * Constants for CustomerView components
 */

// Chart height options for feature explorer
export const CHART_HEIGHT_OPTIONS: IDropdownOption[] = [
  { key: 250, text: "Small (250px)" },
  { key: 300, text: "Medium (300px)" },
  { key: 400, text: "Large (400px)" },
  { key: 500, text: "Extra Large (500px)" }
];

// Feature selection keys
export const SELECT_ALL_KEY = "select-all";
export const DIVIDER_KEY = "divider";

// Default chart height
export const DEFAULT_CHART_HEIGHT = 300;

export const CUSTOMER_VIEW_BREAKPOINTS = [
  { width: 1805, items: 4 },
  { width: 1366, items: 4 },
  { width: 1024, items: 3 },
  { width: 640, items: 3 },
  { width: 480, items: 2 },
  { width: 320, items: 1 }
];

export const VIEWED_KEY = "recentlyViewedCustomers";
export const RECENTLY_VIEWED_LIMIT = 5;

export const CUSTOMER_HEALTH_SCORE_DATA_CUTOFF_DATE = 10;

export const DOWNLOAD_REPORT_ERROR_MESSAGE = "Failed to download the report. Please try again later.";
export const DOWNLOAD_REPORT_TIMEOUT = 3000; // 3 seconds